const mediaItems = [
  {
    title: '最新上映大片混剪',
    desc: '2024暑期档精彩大片片段集锦',
    img: 'https://readdy.ai/api/search-image?query=Film%20editing%20and%20production%20concept%2C%20professional%20video%20editing%20workspace%20with%20warm%20cinematic%20lighting%2C%20creative%20industry%20photography%2C%20artistic%20composition%20with%20film%20elements&width=800&height=520&seq=media-1&orientation=landscape',
    alt: '最新上映大片混剪',
    duration: '03:25',
  },
  {
    title: '热门剧集精彩片段',
    desc: '热播剧高能名场面回顾',
    img: 'https://readdy.ai/api/search-image?query=TV%20series%20highlight%20reel%20concept%2C%20dramatic%20scene%20compilation%20with%20warm%20entertainment%20lighting%2C%20professional%20production%20photography%2C%20cinematic%20composition%20with%20dramatic%20mood&width=800&height=520&seq=media-2&orientation=landscape',
    alt: '热门剧集精彩片段',
    duration: '05:12',
  },
  {
    title: '经典电影回顾解说',
    desc: '重温影史经典，深度解读名作',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20review%20and%20analysis%20concept%2C%20vintage%20cinema%20aesthetic%20with%20warm%20nostalgic%20lighting%2C%20film%20critique%20atmosphere%2C%20professional%20photography%20with%20classic%20elements&width=800&height=520&seq=media-3&orientation=landscape',
    alt: '经典电影回顾解说',
    duration: '08:40',
  },
  {
    title: '新片预告抢先看',
    desc: '即将上映大片预告合集',
    img: 'https://readdy.ai/api/search-image?query=Movie%20trailer%20premiere%20concept%2C%20theatrical%20coming%20soon%20atmosphere%20with%20dramatic%20warm%20lighting%2C%20cinema%20excitement%20aesthetic%2C%20professional%20photography%20with%20anticipation%20mood&width=800&height=520&seq=media-4&orientation=landscape',
    alt: '新片预告抢先看',
    duration: '02:18',
  },
  {
    title: '影视幕后花絮特辑',
    desc: '电影拍摄背后的有趣故事',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%2C%20professional%20movie%20set%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20filmmaking%20documentary%20style%2C%20artistic%20composition%20with%20production%20elements&width=800&height=520&seq=media-5&orientation=landscape',
    alt: '影视幕后花絮特辑',
    duration: '06:55',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩看点
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            热门影视内容精选，发现更多精彩
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className={`group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl md:text-2xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/65 text-white text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}